import React, { ReactNode } from 'react';
import './style.css';
import { Heading, LogoBanner, Modal, Spinner } from '@vwfs-bronson/bronson-react';
import { CustomerState } from '../../../redux/slices/customer-state';
import { LogoutNavButton } from '../navigation-button';
import { removeAuthConfig } from "../../../utils/auth-utils";
import { useAuth } from "react-oidc-context";
import { resetErrorDialog } from '../../../redux/slices/notification-slice';
import { useAppDispatch } from '../../../redux/hooks';
import { resetCustomer, setSearchTerm } from '../../../redux/slices/customer-slice';
import { useNavigate } from 'react-router-dom';

interface IHeaderProps {
  customer?: CustomerState;
  children: ReactNode | ReactNode[];
  leftNavActions?: ReactNode,
  loading?: boolean;
  errorDialog?: {
    message: string;
    title: string;
    code: string;
  }
}

export default function AppWrapper({ children, customer, leftNavActions, loading = false, errorDialog }: IHeaderProps) {
  const auth = useAuth();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const logout = () => {
    removeAuthConfig();
    auth.removeUser();
    auth.signoutRedirect({
      id_token_hint: auth.user?.id_token,
    });
    auth.clearStaleState();
  }

  const handleConfirmErrorDialog = () => {
    dispatch(resetErrorDialog());
  };

  const navigateToStartpage = () => {
    dispatch(setSearchTerm(undefined));
    dispatch(resetErrorDialog());
    dispatch(resetCustomer());
    navigate('/');
  };

  return (
    <div className="App">
      <div className="column">
        <div className="c-header__wrapper" data-testid="heading">
          <div data-testid="CustomerSearchLabel" className='c-header c-header--static'>
            <div data-testid="AppWrapperHeading" className='c-header__content-wrapper'>
              <LogoBanner
                imageProps={{
                  alt: 'Back-Office MobilityApp',
                  src: "https://cdn.bronson.vwfs.tools/bluelabel/v/15.6.0/img/logo.svg",
                }}
                className='banner'
                logoHeight='180px'
                onClick={navigateToStartpage}
              />
              <div className='banner-heading' data-testid="HeaderHeading">
                <Heading level={6} className="display-inline">
                  Back-Office MobilityApp
                </Heading>
              </div>
            </div>
          </div>
        </div>

        {
          customer ?
            <>
              <div className='navigation-bar'>
                <div className='navigation-left'>
                  {leftNavActions}
                </div>
                <div className='navigation-right'>
                  <LogoutNavButton onClickAction={logout} />
                </div>
              </div>
            </>
            :
            null
        }

        <div id="body-content" className="container">
          {children}
        </div>
      </div>

      <Spinner fullPage busy={loading} testId='searchSpinner' />

      <Modal
        shown={errorDialog?.code !== undefined}
        onClose={handleConfirmErrorDialog}
        onConfirm={handleConfirmErrorDialog}
        buttonConfirmLabel="Ok"
        buttonConfirmText="Ok"
        title={errorDialog?.title}
        status='error'
        testId='confirmErrorModal'
      >
        <p>{errorDialog?.message}</p>
      </Modal>

    </div>
  );
}
